export default __webpack_public_path__ + "static/ddThumbnail-d04e972946d8c55afc03fe2a32f7d510.png";